import gql from 'graphql-tag';
export default gql`
  mutation UpdateTextblockById($input: UpdateTextblockByIdInput!) {
    updateTextblockById(input: $input) {
      clientMutationId
    }
  }
`;
